import { Sun, Moon } from "lucide-react";
import { useTheme } from "./ThemeContext.jsx";

export default function ThemeToggle({ compact = false }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  if (compact) {
    return (
      <button
        onClick={toggleTheme}
        aria-label={isDark ? "Mudar para modo claro" : "Mudar para modo escuro"}
        className="p-2 rounded-lg text-ink hover:bg-border/40 transition-colors"
      >
        {isDark ? <Sun size={18} /> : <Moon size={18} />}
      </button>
    );
  }

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? "Mudar para modo claro" : "Mudar para modo escuro"}
      className="w-full flex items-center justify-between gap-3 px-4 py-2.5 rounded-lg text-ink-soft hover:text-ink hover:bg-border/40 transition-colors text-sm font-medium"
    >
      <span className="flex items-center gap-2.5">
        {isDark ? <Sun size={16} /> : <Moon size={16} />}
        {isDark ? "Modo claro" : "Modo escuro"}
      </span>
      <span className="text-[11px] font-mono opacity-60">
        {isDark ? "light" : "dark"}
      </span>
    </button>
  );
}
